/** @jsxImportSource @emotion/react */

import React from "react";
import { css } from "@emotion/react";
import { ChromePicker } from "react-color";
import { Box } from "reflexbox";

export function ColorPicker({ color, onChange }) {
	let [pickerOpen, setPickerOpen] = React.useState(false);

	return (
		<Box>
			<div
				onClick={() => {
					setPickerOpen(!pickerOpen);
				}}
				css={css`
					width: 32pt;
					height: 14pt;
					border-radius: 2pt;
					background-color: ${color};
					box-shadow: 0 0pt 0pt 0.85pt #ced4da;
					cursor: pointer;
					transform: scale(0.95);
					transition: transform 0.3s, box-shadow 0.3s;
					&:hover {
						transform: scale(1);
					}
					&:active {
						transform: scale(0.8);
					}
				`}
			></div>
			{pickerOpen && (
				<>
					<div
						onClick={() => {
							setPickerOpen(!pickerOpen);
						}}
						css={css`
							background-color: #11111122;
							position: fixed;
							top: 0;
							left: 0;
							right: 0;
							bottom: 0;
							z-index: 90;
							display: block;
						`}
					></div>
					<div
						css={css`
							position: absolute;
							margin-top: 2pt;
							z-index: 100;
						`}
					>
						<ChromePicker
							disableAlpha={true}
							color={color}
							onChange={onChange}
						/>
					</div>
				</>
			)}
		</Box>
	);
}
